<template>
  <div class="overflow-y-scroll">
    <section>
      <div class="form-inline flex-row">
        <label>Name:</label>
        <div>
          <input type="text" placeholder="Name" v-model="editName" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Link:</label>
        <div>
          <input type="text" placeholder="Link" v-model="editLink" />
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Synonyms:</label>
        <div
          class="input-group input-prepend input-append"
          v-for="(synonym, index) in editSynonyms"
          :key="index"
        >
          <input
            type="text"
            placeholder="Synonym"
            v-model="editSynonyms[index]"
          />
          <a
            href="javascript:void(0)"
            class="input-prepend-btn"
            @click="addSynonym(index)"
          >
            <i class="material-icons-outlined align-middle">add</i>
          </a>
          <a
            href="javascript:void(0)"
            class="input-apend-btn"
            @click="deleteSynonym(index)"
          >
            <i class="material-icons-outlined align-middle">delete</i>
          </a>
        </div>
      </div>
      <div class="form-inline flex-row">
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="buttonClick"
          >{{ buttonLabel }}</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
import * as database from "@/vendor/database";
import spinnerButton from "@/components/public/SpinnerButton";

export default {
  props: ["propsData"],
  components: {
    spinnerButton,
  },
  data() {
    return {
      panelTitle: null,
      buttonLabel: null,
      editType: null,
      submitLoading: false,
      editName: null,
      editLink: null,
      editSynonyms: [""],
    };
  },
  created: function () {
    this.initData();
  },
  watch: {
    propsData: function () {
      this.initData();
    },
  },
  methods: {
    initData: function () {
      this.editType = this.propsData.type;
      if (this.editType == "add") {
        this.panelTitle = "Add Tool";
        this.buttonLabel = "Add Tool";
      }
      if (this.editType == "edit") {
        this.panelTitle = "Edit Tool";
        this.buttonLabel = "Edit Tool";
      }
      this.editName = this.propsData.name;
      this.editLink = this.propsData.link;
      this.editSynonyms =
        !this.propsData.synonyms || this.propsData.synonyms.length === 0
          ? [""]
          : this.propsData.synonyms;
    },
    freshSynonyms: function () {
      this.$forceUpdate();
    },
    addSynonym: function (index) {
      this.editSynonyms.splice(index + 1, 0, "");
      this.freshSynonyms();
    },
    deleteSynonym: function (index) {
      this.editSynonyms.splice(index, 1);
      if (this.editSynonyms.length == 0) {
        this.editSynonyms.push("");
      }
      this.freshSynonyms();
    },
    buttonClick: function () {
      if (this.editName) {
        const synonyms = this.editSynonyms.filter((item) => item);
        if (this.editType === "add") {
          this.submitLoading = true;
          database
            .addDoc("tools", {
              name: this.editName,
              link: this.editLink,
              synonyms,
            })
            .then((result) => {
              if (result.ok) {
                this.$toasted.global.toast_success({
                  message: "add success",
                });
                this.$emit("closePanel");
              } else {
                this.$toasted.global.toast_error({ message: "add error" });
              }
            })
            .catch((error) => {
              this.$toasted.global.toast_error({ message: error });
            })
            .finally(() => {
              this.submitLoading = false;
            });
        } else if (this.editType === "edit") {
          this.submitLoading = true;
          database
            .updateDocById("tools", this.propsData.id, {
              name: this.editName,
              link: this.editLink,
              synonyms,
            })
            .then((result) => {
              if (result.ok) {
                this.$toasted.global.toast_success({
                  message: "edit success",
                });
                this.$emit("closePanel");
              } else {
                this.$toasted.global.toast_error({ message: "edit error" });
              }
            })
            .catch((error) => {
              this.$toasted.global.toast_error({ message: error });
            })
            .finally(() => {
              this.submitLoading = false;
            });
        }
      }
    },
  },
};
</script>
